// ---------------------------------------------------------------------------
// Whether the menu is open.
//
// The sidebar is 216px of every screen, and on a laptop that is a fifth of
// the room a timeline or a stage wants. It can shrink to nothing and come
// back on a click. The choice is per-browser, not per-account, for the same
// reason the theme is (theme.ts): it is a property of the screen somebody is
// sitting at, and the same creator wants it open on a monitor and closed on
// a laptop.
//
// Unset means "decide from the width": open on a wide window, closed on a
// narrow one. Once the creator has clicked, their choice wins.
// ---------------------------------------------------------------------------

const KEY = 'rookery.nav';

/** The remembered choice, or null when the creator has never made one. */
export function readNav(): boolean | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'open' ? true : v === 'closed' ? false : null;
  } catch {
    return null;
  }
}

export function writeNav(open: boolean): void {
  try { localStorage.setItem(KEY, open ? 'open' : 'closed'); } catch { /* see theme.ts */ }
}

/** Below this the menu starts closed, so the work gets the room. */
export const NARROW = 1100;

export function navDefault(width: number): boolean {
  return width >= NARROW;
}
